<div class="tenant-home">
    @if (customPageSafeUrl) {
    <iframe [src]="customPageSafeUrl" class="tenant-iframe" frameborder="0" allowfullscreen></iframe>
    }
</div>